<div class="small-sidenav" (change)="$event.stopPropagation()">


  <common-side-nav
    class="common-side-nav"
    [side]="'right'"
    #storeLayerNav
    [isSidePanelToggled]="isSidePanelToggled"
    [modalName]="heading"
    panelBodyClass="scrollable-body"
    tabindex="0">

    <div id="store-layer-wrapper" ngProjectAs="myPanelCover">
      <button type="button" data-cy="change-store-btn" class="store-text">
        <span class="hmf-body-bold-m hmf-text-decoration-underline">{{changeStoreText}}</span>
      </button>
    </div>
    <div ngProjectAs="myCustomHeader" class="hmf-display-flex hmf-align-items-center">
      @if (chainIdentifierAbbr !== 'pl' && chainIdentifierAbbr !== 'mj') {
        <img
          class="panel-header-image" src="assets/image/dsg_store.svg"
          loading="lazy"
          alt="Dick's Sporting Goods Store Logo" />
      }
      @if (chainIdentifierAbbr === 'pl') {
        <img
          class="pl-panel-header-image"
          src="assets/icons/pl/StoreIcon.svg"
          loading="lazy"
          alt="Public Lands Store Logo" />
      }
      {{ heading }}
    </div>





    <div class="side-nav-body" ngProjectAs="myCustomBody">

      <!-- Store Layer 3.0 Body Start-->
      <div class="store-layout" data-cy="store-layer-side-panel">
        <div class="store-container">
          <div class="search-form-container">
            <div class="searchContent">
              <div class="store-search-input-container">

                <div class="store-search-input" [ngClass]="{'error': searchError}">
                  <homefield-icon width="12px" height="12px" name="search-outline"></homefield-icon>
                  <input
                    id="zip-code"
                    data-cy="store-search-zipcode-input"
                    name="zip-code"
                    type="text"
                    placeholder="Zip Code"
                    [(ngModel)]="zipCode"
                    [maxlength]="5"
                    (keyup.enter)="getStoreDetails(zipCode, getSkuIdentifier, quantity, this.isBuyable, true, true)"/>
                </div>

                <button
                  class="search-button"
                  data-cy="store-search-btn"
                  aria-label="Search For Store"
                  (click)="getStoreDetails(zipCode, getSkuIdentifier, quantity, this.isBuyable, true, true)">
                  <homefield-icon
                    width="20px"
                    height="20px"
                    name="arrow-right-outline"
                    class="navigation-arrow-forward">
                  </homefield-icon>
                </button>
              </div>
              <div class="store-search-options">
                <button class="current-location-pointer" (click)="userCurrentLocation(getSkuIdentifier, quantity, true)">
                  <homefield-icon width="12px" height="12px" name="location-nearme-fill" class="location-nearme"></homefield-icon>
                  <p>Use Current Location</p>
                </button>

                <div class="hmf-display-flex">
                  @if (getSkuIdentifier) {
                    <div class="check-availability">
                      <input type="checkbox" [id]="checkboxIdRandom" class="checkbox" (click)="isAvailabilitySelected = !isAvailabilitySelected; getStoreDetails(zipCode, getSkuIdentifier, quantity, this.isBuyable, true, true)" [checked]="isAvailabilitySelected">
                      <label [for]="checkboxIdRandom" class="checkbox-label"><span>@if (boplExperienceEnabled) {
                        <span class="hmf-pr-xxxs">All</span>
                        }@if (!boplExperienceEnabled) {
                        <span class="hmf-pr-xxxs">Show</span>
                      }Stores w/ Availability</span></label>
                    </div>
                  }

                  @if (getSkuIdentifier && boplExperienceEnabled) {
                    <div class="check-availability">
                      <input type="checkbox" id="pickup-today-checkbox-{{storeLayerItems[0]?.id}}" class="checkbox" (click)="isPickupTodaySelected = !isPickupTodaySelected; getStoreDetails(zipCode, getSkuIdentifier, quantity, this.isBuyable, true, true)" (keydown.space)="isPickupTodaySelected = !isPickupTodaySelected; getStoreDetails(zipCode, getSkuIdentifier, quantity, this.isBuyable, true, true)" [checked]="isPickupTodaySelected">
                      <label for="pickup-today-checkbox-{{storeLayerItems[0]?.id}}" class="checkbox-label"><span>Pickup Today</span></label>
                    </div>
                  }
                </div>
              </div>

            </div>
          </div>

          @if (searchError && chainIdentifierAbbr !== 'pl') {
            <div>
              <common-alert-message messageTitle="" [messageBody]="searchErrorMessage" messageLevel="error"></common-alert-message>
            </div>
          }

          @if (searchError && chainIdentifierAbbr === 'pl') {
            <div>
              <common-alert-message [messageTitle]="searchErrorMessage" messageBody="" messageLevel="error"></common-alert-message>
            </div>
          }

          <div class="hmf-mt-xxs" [class.hmf-display-none]="!loading" alt="spinner"><common-progress-spinner [diameter]="40" [strokeWidth]="4"></common-progress-spinner></div>
          <div class="store-details-container">
            <div class="store-details">
              @if (searchClicked && storeResults) {
                <div class="available-store-count" [class.available-store-count-g3]="chainIdentifierAbbr === 'g3'">
                  @if (storeResults?.length > 0) {
                    <p class="store-count hmf-my-xxs"><span class="hours-heading">{{storeResults?.length}} stores</span> within {{ storeSearchRadius }} miles.</p>
                  }
                  @if (storeResults?.length === 0 && (chainIdentifierAbbr !== 'pl' && chainIdentifierAbbr !=='g3')) {
                    <p class="store-count hmf-my-xxs">We found <span class="hours-heading">0 stores</span> within {{ storeSearchRadius }} miles of your location.</p>
                  }
                  @if (storeResults?.length === 0 && (chainIdentifierAbbr === 'pl' || chainIdentifierAbbr === 'g3')) {
                    <p class="store-count hmf-my-xxs">No store found within {{ storeSearchRadius }} miles of this zip code. We're working on expanding.</p>
                  }
                </div>
              }

              @if (storeResults?.length > 0) {
                <hmf-radio-group
                  class="store-information-container"
                  name="store-select-radio-{{storeLayerItems[0]?.id}}"
                  aria-label="Store Selection"
                  [value]="storeResults[nextStoreIndex]?.store?.location ?? null">
                  @for (storeResult of storeResults; track trackByFn(i, storeResult); let i = $index) {
                    <div id="stores">
                      <hmf-radio
                        class="store-select-radio"
                        [id]="storeResult.store.location + '-' + storeLayerItems[0]?.id"
                        [value]="storeResult.store.location"
                        [attr.data-cy]="'store-select-radio-btn_' + i"
                        (eventChange)="selectStore(i)">
                        <div class="store-information" [class.selected-store-heading]="i === selectedStoreIndex">
                          <p class="user-store-label">My Store</p>
                          <div class="store-heading">
                            @if (crossChainBopis && chainIdentifierAbbr !== 'g3' && storeResult?.store?.name !=='GOING, GOING, GONE!') {
                              <div class="store-heading">
                                <span>
                                  <source type="image/webp" [srcset]="$safeNavigationMigration(storeResult?.store?.logo)"/>
                                  <img alt="logo" [src]="$safeNavigationMigration(storeResult?.store?.logo)" loading="lazy">
                                </span><br/>
                              </div>
                            }
                            <span class="store-name" [ngClass]="$safeNavigationMigration(storeResult?.store?.titleStyle)">{{storeResult.store.name | titlecase}}</span> | <span class="store-miles">{{storeResult.distance}} mi</span>
                          </div>
                          @if (storeResult.store.street1) {
                            <p class="store-street">{{storeResult.store.street1 | titlecase}}</p>
                          }
                          <div class="sku-availability">
                            @if (storeResult.skus && storeService.isSkuSelected(storeLayerItems)) {
                              <div>
                                @if (displayAvailableForPickup(storeResult, quantity)) {
                                  <div><homefield-icon width="16px" height="16px" name="sign-circled-check-fill" class="sign-circled-check"></homefield-icon><span>Available for Pickup</span></div>
                                }
                                @if (isStoreOpen(storeResult.store.status) && !canPickupCurbside(storeResult, quantity) && !availableToPurchaseInStore(storeResult, quantity) && !(!availableToPurchaseInStore(storeResult, quantity) && !canPickupCurbside(storeResult, quantity))) {
                                  <div><homefield-icon width="16px" height="16px" name="alert-error-fill" class="alert-error-filled"></homefield-icon><span>Not available for Curbside Contactless Pickup</span></div>
                                }
                                @if (displayInStoreOnlyMessage(storeResult, quantity)) {
                                  <div><span class="in-store-purchase">In-Store Purchase Only</span></div>
                                }
                                @if (displayAvailableToPurchaseInStore(storeResult, quantity)) {
                                  <div><homefield-icon width="16px" height="16px" name="sign-circled-check-fill" class="sign-circled-check"></homefield-icon><span>Available to Purchase in Store</span></div>
                                }
                                @if (displayNotAvailableInStore(storeResult,quantity)) {
                                  <div><homefield-icon width="16px" height="16px" name="alert-error-fill" class="alert-error-filled"></homefield-icon><span>Not available to Purchase in Store</span></div>
                                }
                                @if (displayNotAvailableMessageAndStoreOpen(storeResult, quantity) || displayNotAvailableMessageAndClosedToFootTraffic(storeResult)) {
                                  <div><homefield-icon width="16px" height="16px" name="alert-error-fill" class="alert-error-filled"></homefield-icon><span>Not Available</span></div>
                                }
                                @if (isStoreOpen(storeResult.store.status) && qtyExceedsStoreAvailability(storeResult, quantity) && !displayAvailableForPickup(storeResult, quantity)) {
                                  <div><homefield-icon width="16px" height="16px" name="alert-error-fill" class="alert-error-filled"></homefield-icon><span>Quantity selected exceeds store availability.</span></div>
                                }
                                @if (displayClosedToFootTraffic(storeResult)) {
                                  <div><homefield-icon width="16px" height="16px" name="alert-error-fill" class="alert-error-filled"></homefield-icon><span class="store-layer-alert-msg">Store closed to foot traffic</span></div>
                                }
                                @if (displayStoreTemporarilyClosed(storeResult)) {
                                  <div><homefield-icon width="16px" height="16px" name="alert-error-fill" class="alert-error-filled"></homefield-icon><span>Not Available. Store is Temporarily Closed.</span></div>
                                }
                                @if (displayPickupLaterMessage(storeResult, quantity)) {
                                  <div><homefield-icon width="16px" height="16px" name="sign-circled-check-fill" class="sign-circled-check"></homefield-icon><span>Available to Ship to Store</span><br><span class="bopl-message">Available for Pickup in 5 - 10 Business Days</span></div>
                                }
                              </div>
                            }
                            @if (!storeResult.skus || !storeService.isSkuSelected(storeLayerItems) && isStoreOpen(storeResult.store.status)) {
                              <div class="select-store-text">
                                <div>
                                  <div><p>Select product options to see item availability at each store</p></div>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </hmf-radio>
                      <!-- Store Information -->
                      <div class="store-information">
                        <common-accordion [isDisabled]="false" [isCollapsed]="true" [hideHeaderLine]="true" [isTitleCentered]="false" [arrowIconSmall]="true" (accordionClicked)="storeInfoClicked($event, i)">
                          <div class="accordian-header" myPanelHeader>
                            <button class="store-details-dropdown">Store Info</button>
                          </div>
                          <div myPanelBody>
                            <div class="store-contact">
                              <p class="store-get-direction">
                                <a target="_blank" href="{{storeResult.store.mapUrl}}" class="store-hour-actions">
                                  <!-- On Icon -->
                                  <homefield-icon width="12px" height="12px" name="location-pin-fill"></homefield-icon>
                                  <p>Get Directions</p></a>
                                </p>
                                <p class="phone">
                                  <a [href]="'tel:' + storeResult.store.phone | dcsgSanitizeUrl" class="cta flex-box">
                                    <homefield-icon width="12px" height="12px" name="mobile-phone-fill"></homefield-icon>
                                    <p>{{storeResult.store.phone}}</p></a>
                                  </p>
                                </div>
                                <div class="store-address-container">
                                  @if (storeResult.store.street1) {
                                    <div>{{storeResult.store.street1 | titlecase}}</div>
                                  }
                                  @if (storeResult.store.street2) {
                                    <div>{{storeResult.store.street2 | titlecase}}</div>
                                  }
                                  @if (storeResult.store.city) {
                                    <div>{{storeResult.store.city | titlecase}}, {{storeResult.store.state | uppercase}}
                                      {{storeResult.store.zip}}
                                    </div>
                                  }
                                </div>
                                <div class="store-hours-container">
                                  <strong class="hours-heading">Store Hours</strong>
                                  @if (storeResult.storeHoursclosedAllDays) {
                                    <div>
                                      <div class="store-hours"><span></span><span>Closed</span></div>
                                    </div>
                                  }
                                  @if (!storeResult.storeHoursclosedAllDays) {
                                    <div>
                                      <div class="store-hours"><span>Monday</span><span>{{ storeResult.store.storeHours.mon }}</span></div>
                                      <div class="store-hours"><span>Tuesday</span> <span>{{ storeResult.store.storeHours.tue }}</span></div>
                                      <div class="store-hours"><span>Wednesday</span> <span>{{ storeResult.store.storeHours.wed }}</span></div>
                                      <div class="store-hours"><span>Thursday</span> <span>{{ storeResult.store.storeHours.thu }}</span></div>
                                      <div class="store-hours"><span>Friday</span> <span>{{ storeResult.store.storeHours.fri }}</span></div>
                                      <div class="store-hours"><span>Saturday</span> <span>{{ storeResult.store.storeHours.sat }}</span></div>
                                      <div class="store-hours"><span>Sunday</span> <span>{{ storeResult.store.storeHours.sun }}</span></div>
                                    </div>
                                  }
                                </div>
                                <br/>
                                <div class="store-hours-container">
                                  <strong class="hours-heading">Curbside Hours</strong>
                                  @if (storeResult.curbsideHoursclosedAllDays) {
                                    <div>
                                      <div class="store-hours"><span></span><span>Closed</span></div>
                                    </div>
                                  }
                                  @if (!storeResult.curbsideHoursclosedAllDays) {
                                    <div>
                                      <div class="store-hours"><span>Monday</span><span>{{ storeResult.store.curbsideHours.mon }}</span></div>
                                      <div class="store-hours"><span>Tuesday</span> <span>{{ storeResult.store.curbsideHours.tue }}</span></div>
                                      <div class="store-hours"><span>Wednesday</span> <span>{{ storeResult.store.curbsideHours.wed }}</span></div>
                                      <div class="store-hours"><span>Thursday</span> <span>{{ storeResult.store.curbsideHours.thu }}</span></div>
                                      <div class="store-hours"><span>Friday</span> <span>{{ storeResult.store.curbsideHours.fri }}</span></div>
                                      <div class="store-hours"><span>Saturday</span> <span>{{ storeResult.store.curbsideHours.sat }}</span></div>
                                      <div class="store-hours"><span>Sunday</span> <span>{{ storeResult.store.curbsideHours.sun }}</span></div>
                                    </div>
                                  }
                                </div>
                              </div>
                            </common-accordion>
                          </div>
                        </div>
                      }
                    </hmf-radio-group>
                  }
                </div>
              </div>
            </div>
            <div class="store-pickup-controls hmf-elevated-up-shadow">
              <button
                hmf-button
                aria-label="Clear"
                class="store-pickup-controls-close-btn"
                variant="secondary"
                (click)="storeLayerNav.panelToggle('close')"
                text="Cancel"
              ></button>
              <button
                hmf-button
                data-cy="set-store-btn"
                aria-label="Set Store"
                class="store-pickup-controls-set-store-btn"
                variant="primary"
                [disabled]="loading || !storeResults?.length || nextStoreIndex === null"
                (click)="setCustomerStore()"
                text="Set Store"
              ></button>
            </div>
          </div>
          <!-- Store Layer 3.0 Body End-->
        </div>
      </common-side-nav>
    </div>
